import React from "react";
import { Search, Clock } from "lucide-react";
import { format } from "date-fns";

export interface CustomerPackageLog {
  id: number;
  customerName: string;
  actionDescription: string;
  updatedByName: string;
  updatedAt: string;
}

interface CustomerPackageLogsTableProps {
  logs: CustomerPackageLog[];
  isLoading: boolean;
  indexOfFirstItem: number;
}

export const CustomerPackageLogsTable: React.FC<CustomerPackageLogsTableProps> = ({
  logs,
  isLoading,
  indexOfFirstItem,
}) => {
  const formatDate = (dateString: string): string => {
    try {
      const date = new Date(dateString);
      return format(date, "MMM dd, yyyy HH:mm");
    } catch {
      return dateString;
    }
  };

  return (
    <div className="flex-1 overflow-y-auto relative">
      <table className="w-full">
        <thead className="sticky top-0 z-10 bg-[#885ABB] border-b border-gray-100">
          <tr className="grid grid-cols-12 gap-4 text-sm font-bold text-white tracking-wide px-6 py-4">
            <th className="col-span-1 text-left font-bold">#</th>
            <th className="col-span-3 text-left font-bold">Customer</th>
            <th className="col-span-5 text-left font-bold">Action Description</th>
            <th className="col-span-2 text-left font-bold">Updated By</th>
            <th className="col-span-1 text-left font-bold">Date & Time</th>
          </tr>
        </thead>
        <tbody className="w-full divide-y divide-gray-100 bg-white">
          {isLoading ? (
            <tr className="h-64 w-full">
              <td colSpan={12} className="h-full">
                <div className="flex h-full w-full items-center justify-center">
                  <div className="h-8 w-8 animate-spin rounded-full border-4 border-[#885ABB] border-t-transparent"></div>
                </div>
              </td>
            </tr>
          ) : logs.length === 0 ? (
            <tr className="flex flex-col items-center justify-center h-64 text-gray-400 w-full">
              <td className="w-full h-full flex flex-col items-center justify-center">
                <Search className="w-12 h-12 mb-3 opacity-20" />
                <p className="text-lg font-medium text-gray-500">
                  No logs found
                </p>
                <p className="text-sm">Try adjusting your search terms</p>
              </td>
            </tr>
          ) : (
            <>
              {logs.map((log, idx) => (
                <tr
                  key={log.id}
                  className="grid grid-cols-12 gap-4 px-6 py-4 hover:bg-purple-50/30 transition-colors bg-white group text-sm w-full"
                >
                  <td className="col-span-1 text-gray-500 font-medium">
                    {indexOfFirstItem + idx + 1}
                  </td>
                  <td className="col-span-3 font-semibold text-gray-800 group-hover:text-[#885ABB] transition-colors">
                    {log.customerName}
                  </td>
                  <td className="col-span-5 text-gray-700">
                    <div className="flex items-start gap-2">
                      {/* <Clock size={14} className="mt-0.5 text-gray-400 flex-shrink-0" /> */}
                      <span className="text-xs leading-relaxed">{log.actionDescription}</span>
                    </div>
                  </td>
                  <td className="col-span-2 text-gray-600 text-xs">
                    {log.updatedByName}
                  </td>
                  <td className="col-span-1 text-gray-500 text-xs">
                    {formatDate(log.updatedAt)}
                  </td>
                </tr>
              ))}
            </>
          )}
        </tbody>
      </table>
    </div>
  );
};

